import React from 'react'
import PropTypes from 'prop-types'

import UI5CalendarContent from "./day-selection/calendar-content"
import UI5CalendarMonthSelection from "./month-selection/month-selection"
import UI5CalendarPresets from "./calendar-presets";
import {findDOMNode} from "react-dom";

const debug = false
// const debug = "UI5Calendar"

export default class UI5Calendar extends React.Component {
    static propTypes = {
        skin            : PropTypes.oneOf(['default', 'menu']),

        selectedDays        : PropTypes.arrayOf(PropTypes.shape({
            startDate   : PropTypes.object,                     //Moment
            endDate     : PropTypes.object,                     //Moment
            className   : PropTypes.string
        })),

        disabledDays        : PropTypes.arrayOf(PropTypes.shape({
            startDate   : PropTypes.object,                     //Moment
            endDate     : PropTypes.object,                     //Moment
            className   : PropTypes.string
        })),

        minDate             : PropTypes.object,                 // Moment, adds disabled option for view + no event on click
        maxDate             : PropTypes.object,

        daySize             : PropTypes.oneOf([30,36]),

        dndManager          : PropTypes.object,
        calendarDayDnd      : PropTypes.func,                   // special class to override control for drop into calendar days

        showTodayButton     : PropTypes.bool,                   // show button beside month title to jump to today on click
        customButtons       : PropTypes.arrayOf(PropTypes.shape({
            label       : PropTypes.string,
            icon        : PropTypes.string,
            className   : PropTypes.string,
            onClick     : PropTypes.func,
        })),
        customButtonsNoBg   : PropTypes.bool,                   // presets without contrast background and border

        onSelect            : PropTypes.func,                   // on date selected -> returns moment
    }

    static defaultProps = {
        skin            : 'default',
        daySize         : 36,
        showTodayButton : true
    }



    constructor(props) {
        super(props)

        this.height = null

        this.state = {
            mode            : 'day-selection',
            initialMonth    : null
        }
    }

    onClickMonthSelection = (monthMoment) => {
        this.height = findDOMNode(this).offsetHeight // to remain same height as in day-selection mode

        this.setState({
            mode        : 'month-selection',
            initialMonth: monthMoment
        })
    }

    onBack = () => {
        this.height = null

        this.setState({
            mode        : 'day-selection'
        })
    }

    onSelectMonth = (monthMoment) => {
        this.setState({
            mode        : 'day-selection',
            initialMonth: monthMoment
        })
    }

    render() {
        debug && console.log(debug, "render", this.props.selectedDays)

        // experimental
        let initialMonth = this.state.initialMonth
        if (!this.state.initialMonth && this.props.selectedDays && this.props.selectedDays[0]?.startDate) {
            initialMonth = this.props.selectedDays[0].startDate
        }
        // console.log("CalendarSingle.jsx initialMonth=", initialMonth.format("YYYY-MM-DD"))
        //

        const navigationArrowsPosition = this.props.skin === 'menu' ? "right" : undefined

        const classes = Classes("ui5-calendar-2", "day-size-{0}".f(this.props.daySize), '{0}-skin'.f(this.props.skin), this.props.className)

        switch (this.state.mode) {
            case 'day-selection':
                return (
                    <div className={classes}>
                        <UI5CalendarPresets presets         = {this.props.customButtons}
                                            noBackground    = {this.props.customButtonsNoBg}/>
                        <UI5CalendarContent initialMonth                = {initialMonth} // this.state.initialMonth
                                            selectedDays                = {this.props.selectedDays}
                                            disabledDays                = {this.props.disabledDays}
                                            focusOnLastDate             = {this.props.focusOnLastDate}
                                            minDate                     = {this.props.minDate}
                                            maxDate                     = {this.props.maxDate}
                                            showTodayButton             = {this.props.showTodayButton}
                                            navigationArrowsPosition    = {navigationArrowsPosition}
                                            dndManager                  = {this.props.dndManager}
                                            calendarDayDnd              = {this.props.calendarDayDnd}
                                            onClickMonthSelection       = {this.onClickMonthSelection}
                                            onSelect                    = {this.props.onSelect}/>
                    </div>
                )

            case 'month-selection':
                return (
                    <div className={classes} style={{height: this.height}}>
                        <UI5CalendarPresets presets         = {this.props.customButtons}
                                            noBackground    = {this.props.customButtonsNoBg}/>
                        <UI5CalendarMonthSelection initialMonth     = {this.state.initialMonth}
                                                   selectedDays     = {this.props.selectedDays}
                                                   onSelectMonth    = {this.onSelectMonth}
                                                   onBack           = {this.onBack}/>
                    </div>
                )
        }
    }
}
